import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { EmbedErrorCode, embedErrorText, isRecoverable } from "./embedBridge";

/**
 * The compact static panels an embedded widget shows instead of app pages: loading, a terminal "done"
 * state, and errors. Fixed text only -- the partner decides what happens next.
 */
export const EmbedLoading = () => (
  <Box
    role="status"
    aria-live="polite"
    sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 240 }}
  >
    <CircularProgress size={32} />
  </Box>
);

export const EmbedDone = ({ title, message }: { title: string; message?: string }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 240, gap: 1, p: 3, textAlign: "center" }}
  >
    <Typography variant="h6" component="p">
      {title}
    </Typography>
    {message && <Typography variant="body2">{message}</Typography>}
  </Box>
);

export const EmbedError = ({
  code,
  onRetry,
}: {
  code: EmbedErrorCode;
  onRetry?: () => void;
}) => (
  <Box
    role="alert"
    sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 240, gap: 1.5, p: 3, textAlign: "center" }}
  >
    <Typography variant="h6" component="p">
      {embedErrorText[code]}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {code}
    </Typography>
    {onRetry && isRecoverable(code) && (
      <Button variant="contained" onClick={onRetry}>
        Try again
      </Button>
    )}
  </Box>
);
